import { call, put } from 'redux-saga/effects';
import api from 'services/api';
import { Creators } from 'store/ducks/orders';

export function* getOrders() {
  try {
    const res = yield call(api.get, `/v1/order/order`);
    const { status, statusText } = res;
    
    if((status === 200 || status===201)){
      const orders = res.data.body;
      yield put(Creators.fetchOrdersSuccess(orders));
    } else {
      yield put(
        Creators.fetchOrdersFailure({
          status: status==='NOT_AUTHORIZED'?401:status,
          message: status==='NOT_AUTHORIZED'?status:statusText,
        })
      );
    }
  } catch (e) {
    const { response, message } = e;
    yield put(
      Creators.fetchOrdersFailure({
        status: response ? response.data.statusCode || response.status : null,
        message,
      }),
    );
  }
}

export function* getOrder({id}) {
  try {
    const res = yield call(api.get, `/v1/order/order?id=${id}`);
    const { status, statusText } = res;
    //console.log(res);
    
    if((status === 200 || status===201)){
      const order = res.data.body;
      yield put(Creators.fetchOrderSuccess(order));
    } else {
      yield put(
        Creators.fetchOrderFailure({
          status: status==='NOT_AUTHORIZED'?401:status,
          message: status==='NOT_AUTHORIZED'?status:statusText,
        })
      );
    }
  } catch (e) {
    const { response, message } = e;
    yield put(
      Creators.fetchOrderFailure({
        status: response ? response.data.statusCode || response.status : null,
        message,
      }),
    );
  }
}

export function* getByOrderNumber({orderNumber}) {
  try {
    const res = yield call(api.get, `/v1/order/order?orderNumber=${orderNumber}`);
    const { status, statusText } = res;
    //console.log(res);
    
    if((status === 200 || status===201)){
      const orders = res.data.body;
      yield put(Creators.fetchByOrderNumberSuccess(orders));
    } else {
      yield put(
        Creators.fetchByOrderNumberFailure({
          status: status==='NOT_AUTHORIZED'?401:status,
          message: status==='NOT_AUTHORIZED'?status:statusText,
        })
      );
    }
  } catch (e) {
    const { response, message } = e;
    yield put(
      Creators.fetchByOrderNumberFailure({
        status: response ? response.data.statusCode || response.status : null,
        message,
      }),
    );
  }
}

export function* getByPagened({provider, filterDateName, dateFrom, dateTo, page, pageSize, filterStatus, isProviderStatus}) {
  try {
    const newStatus = filterStatus === 0 ? '' : filterStatus;
    const newProvider = provider === 'none' ? '' : provider;

    const URL = isProviderStatus 
      ? `/v1/order/order?provider=${newProvider}&filterDateName=${filterDateName}&dateFrom=${dateFrom}&dateTo=${dateTo}&page=${page}&pageSize=${pageSize}&providerStatus=${newStatus}`
      : `/v1/order/order?provider=${newProvider}&filterDateName=${filterDateName}&dateFrom=${dateFrom}&dateTo=${dateTo}&page=${page}&pageSize=${pageSize}&status=${newStatus}`;

    console.log(URL);
      
    const res = yield call(api.get, URL);
    const { status, statusText } = res;
    
    if((status === 200 || status===201)){
      const orders = res.data?.body;
      yield put(Creators.fetchOrdersSuccess(orders));
    } else {
      yield put(
        Creators.fetchOrdersFailure({
          status: status==='NOT_AUTHORIZED'?401:status,
          message: status==='NOT_AUTHORIZED'?status:statusText,
        })
      );
    }
  } catch (e) {
    const { response, message } = e;
    yield put(
      Creators.fetchOrdersFailure({
        status: response ? response.data.statusCode || response.status : null,
        message,
      }),
    );
  }
}

export function* getByProvider({provider, filterDateName, dateFrom, dateTo, filterStatus, isProviderStatus}) {
  try {
    const newStatus = filterStatus === 0 ? '' : filterStatus;
    const newProvider = provider === 'none' ? '' : provider;

    const URL = isProviderStatus
      ? `/v1/order/order?provider=${newProvider}&filterDateName=${filterDateName}&dateFrom=${dateFrom}&dateTo=${dateTo}&providerStatus=${newStatus}`
      : `/v1/order/order?provider=${newProvider}&filterDateName=${filterDateName}&dateFrom=${dateFrom}&dateTo=${dateTo}&status=${newStatus}`;

    console.log(URL);

    const res = yield call(api.get, URL);
    const { status, statusText } = res;
    
    if((status === 200 || status===201)){
      const orders = res.data.body;
      // console.log(orders);
      // console.log(Object.keys(orders[0]));
      yield put(Creators.fetchOrdersSuccess(orders));
    } else {
      yield put(
        Creators.fetchOrdersFailure({
          status: status==='NOT_AUTHORIZED'?401:status,
          message: status==='NOT_AUTHORIZED'?status:statusText,
        })
      );
    }
  } catch (e) {
    const { response, message } = e;
    yield put(
      Creators.fetchOrdersFailure({
        status: response ? response.data.statusCode || response.status : null,
        message,
      }),
    );
  }
}

export function* getAllYear() {
  try {
    const res = yield call(api.get, `/v1/order/reports`);
    const { status, statusText } = res;
    
    if((status === 200 || status===201)){
      const reports = res.data.body;
      yield put(Creators.fetchAllYearSuccess(reports));
    } else {
      yield put(
        Creators.fetchAllYearFailure({
          status: status==='NOT_AUTHORIZED'?401:status,
          message: status==='NOT_AUTHORIZED'?status:statusText,
        })
      );
    }
  } catch (e) {
    const { response, message } = e;
    yield put(
      Creators.fetchAllYearFailure({
        status: response ? response.data.statusCode || response.status : null,
        message,
      }),
    );
  }
}

export function* getByYear({year}) {
  try {
    const res = yield call(api.get, `/v1/order/reports?year=${year}`);
    const { status, statusText } = res;
    
    if((status === 200 || status===201)){
      const reports = res.data.body;
      yield put(Creators.fetchByYearSuccess(reports));
    } else {
      yield put(
        Creators.fetchByYearFailure({
          status: status==='NOT_AUTHORIZED'?401:status,
          message: status==='NOT_AUTHORIZED'?status:statusText,
        })
      );
    }
  } catch (e) {
    const { response, message } = e;
    yield put(
      Creators.fetchByYearFailure({
        status: response ? response.data.statusCode || response.status : null,
        message,
      }),
    );
  }
}

export function* getByDayByDay() {
  try {
    const res = yield call(api.get, `/v1/order/reports?dayToday=true`);
    const { status, statusText } = res;
    
    if((status === 200 || status===201)){
      const reports = res.data.body;
      yield put(Creators.fetchByDayByDaySuccess(reports));
    } else {
      yield put(
        Creators.fetchByDayByDayFailure({
          status: status==='NOT_AUTHORIZED'?401:status,
          message: status==='NOT_AUTHORIZED'?status:statusText,
        })
      );
    }
  } catch (e) {
    const { response, message } = e;
    yield put(
      Creators.fetchByDayByDayFailure({
        status: response ? response.data.statusCode || response.status : null,
        message,
      }),
    );
  }
}

export function* updateOrder({ order }) {
  try {
    const res = yield call(api.put, `/v1/order/order`, order);
    const { status, statusText } = res;
    
    if((status === 200 || status===201)){
      yield put(Creators.putOrderSuccess(order));
    } else {
      yield put(
        Creators.putOrderFailure({
          status: status==='NOT_AUTHORIZED'?401:status,
          message: status==='NOT_AUTHORIZED'?status:statusText,
        })
      );
    }
  } catch (e) {
    const { response, message } = e;
    yield put(
      Creators.putOrderFailure({
        status: response ? response.data.statusCode || response.status : null,
        message,
      }),
    );
  }
}

export function* getFtpOrders({provider}) {
  try {
    const res = yield call(api.get, `/v1/ftp/downloads?provider=${provider}`);
    const { status, statusText } = res;
    
    if((status === 200 || status===201)){
      const ftp = res.data.body;
      console.log('getFtpOrders::ftp', ftp)
      yield put(Creators.downloadFtpOrdersSuccess(ftp));
    } else {
      yield put(
        Creators.downloadFtpOrdersFailure({
          status: status==='NOT_AUTHORIZED'?401:status,
          message: status==='NOT_AUTHORIZED'?status:statusText,
        })
      );
    }
  } catch (e) {
    const { response, message } = e;
    yield put(
      Creators.downloadFtpOrdersFailure({
        status: response ? response.data.statusCode || response.status : null,
        message,
      }),
    );
  }
}